<template>
  <div>
    <!-- 抽屉组件 -->
    <el-dialog
        :visible.sync="drawerVisible"
        :show-close="false"
        width="60%"
    >
      <div class="diglog_h">
        <div>设备选择</div>
        <img src="@/assets/structure/close.png" class="diglog_icon" @click="drawerVisible = false"/>
      </div>
      <div class="device-body">
        <div class="body-content">
          <div class="content-left">
            <div class="left-header">
              <el-input
                  v-model="queryFrom.name"
                  clearable
                  placeholder="搜索设备"
              >
                <i slot="suffix" style="font-size: 14px;cursor: pointer;" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="content check-disable">
              <el-tree
                  ref="treeRef"
                  :data="deviceList"
                  show-checkbox
                  node-key="id"
                  @check-change="handleDeviceCheckChange"
                  class="device-tree"
                  :filter-node-method="filterNode"
                  @node-click="handleNodeClick"
                  :props="{children: 'children', label: 'name'}">
                <template #default="{ node, data }">
                  <div class="custom-tree-node" @click.stop="handleRowClick(1,node, data)">
                    <svg t="1770450054725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="70131" width="14" height="14"><path d="M692.224 121.694316c0.808421 3.718737 3.018105 4.904421 6.736842 3.718737l68.284632-2.15579c60.200421 0 107.088842 52.224 110.268631 115.765895l0.161684 6.898526v687.104h-73.62021V245.921684c0-26.516211-15.737263-46.403368-33.306947-48.828631l-3.503158-0.269474-68.284632 2.155789v681.391158c0 58.853053-46.565053 106.603789-103.962947 106.60379-5.443368 0-10.994526-0.431158-16.384-1.293474l-5.389474-1.077895-331.991579-37.402947c-46.295579-10.24-79.764211-51.038316-82.081684-99.166316l-0.053895-5.12V193.266526c0-48.559158 31.851789-90.758737 77.231158-103.154526l4.850526-1.185684L573.332211 51.469474c56.050526-12.341895 106.927158 12.665263 118.945684 70.224842zM539.486316 444.416a36.810105 36.810105 0 0 0-36.810105 36.810105v73.620211a36.810105 36.810105 0 0 0 73.62021 0V481.28a36.810105 36.810105 0 0 0-36.810105-36.810105z" fill="#707070" fill-opacity=".65" p-id="70132"></path></svg>
                    <span class="label">{{ data.name }}</span><span v-if="data.sn">（{{ data.sn }}）</span>
                  </div>
                </template>
              </el-tree>
            </div>
            <div class="left-bottom">
              <el-checkbox v-model="queryFrom.isAllDevicesSelected" @change="handleSelectAllDevice">全选<span style="margin-left: 5px;">共{{deviceList.length}}台设备</span></el-checkbox>

            </div>
          </div>
          <div class="content-right">
            <div class="content">
              <div class="content-title">
                <div>已选中（{{selectedDeviceList.length}}个设备）</div>
                <div class="deleteAll" @click="handleDeleteAll">清空</div>
              </div>
              <div class="content-body">
                <div class="content-item" v-for="item in selectedDeviceList" :key="item.id">
                  <div class="content-item-text">
                    <svg t="1770450054725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="70131" width="14" height="14"><path d="M692.224 121.694316c0.808421 3.718737 3.018105 4.904421 6.736842 3.718737l68.284632-2.15579c60.200421 0 107.088842 52.224 110.268631 115.765895l0.161684 6.898526v687.104h-73.62021V245.921684c0-26.516211-15.737263-46.403368-33.306947-48.828631l-3.503158-0.269474-68.284632 2.155789v681.391158c0 58.853053-46.565053 106.603789-103.962947 106.60379-5.443368 0-10.994526-0.431158-16.384-1.293474l-5.389474-1.077895-331.991579-37.402947c-46.295579-10.24-79.764211-51.038316-82.081684-99.166316l-0.053895-5.12V193.266526c0-48.559158 31.851789-90.758737 77.231158-103.154526l4.850526-1.185684L573.332211 51.469474c56.050526-12.341895 106.927158 12.665263 118.945684 70.224842zM539.486316 444.416a36.810105 36.810105 0 0 0-36.810105 36.810105v73.620211a36.810105 36.810105 0 0 0 73.62021 0V481.28a36.810105 36.810105 0 0 0-36.810105-36.810105z" fill="#707070" fill-opacity=".65" p-id="70132"></path></svg>
                    <span>{{item.name}}</span><span v-if="item.sn">（{{ item.sn }}）</span>
                  </div>
                  <div>
                    <i class="el-icon-error" style="font-size: 14px;color:gray;cursor: pointer;" @click="handleDelete(item)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="available_frame_bto">
        <div class="available_frame_cancel" @click="handleCancel">取消</div>
        <el-button class="available_frame_comfin" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'DeviceSelectDialog',
  props: {
    local: {
      type: Boolean,
      default: false
    },
    devices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      queryFrom:{
        isAllDevicesSelected: false,
        isAllSpacesSelected: false,
      },
      drawerVisible: false,
      selectedDeviceList: [],
      deviceList: this.devices || [],
    };
  },
  computed: {},
  watch: {
    'queryFrom.name': function (val) {
      this.$refs.treeRef.filter(val);
    },
    devices: function (val) {
      this.deviceList = val;
    },
  },
  methods: {
    show(list) {
      this.drawerVisible = true;
      this.selectedDeviceList = list || [];
      this.$nextTick(() => {
        this.$refs.treeRef?.setCheckedKeys([]);
        this.selectedDeviceList.forEach(row => {
          this.$refs.treeRef?.setChecked(row.id, true,true);
        })
      })
    },
    handleSelectAllDevice(){
      const tree =  this.$refs.treeRef;
      if(this.queryFrom.isAllDevicesSelected){
        tree.setCheckedKeys(this.deviceList.map(item => item.id));
      }else{
        tree.setCheckedKeys([]);
      }
    },
    handleDeviceCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      if(checked){
        if(!this.selectedDeviceList.find( d => d.id == data.id)){
          this.selectedDeviceList.push(data);
        }
      }else{
        this.selectedDeviceList = this.selectedDeviceList.filter((d) => d.id !== data.id);
      }
    },

    handleDelete(row){
      this.selectedDeviceList = this.selectedDeviceList.filter((d) => d.id !== row.id);
      this.$refs.treeRef?.setChecked(row.id, false,true);
    },
    handleDeleteAll(){
      this.selectedDeviceList = [];
      this.$refs.treeRef?.setCheckedKeys([]);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 || data.sn.indexOf(value) !== -1;
    },
    handleNodeClick (data, node) {
      // 这里可以处理节点点击的其他逻辑
      console.log('节点点击:', data, node)
    },
    handleRowClick (type,node, data) {
      // 切换节点的勾选状态
      this.$refs.treeRef.setChecked(node.key, !node.checked, true)
    },
    // 取消按钮
    handleCancel() {
      this.drawerVisible = false;
      this.$emit('cancel');
    },
    // 确定按钮
    handleConfirm() {
      this.$emit('confirm', this.selectedDeviceList);
      this.drawerVisible = false;
    },
  },
};
</script>

<style scoped>
.device-body{
  padding: 10px;
}
.body-content {
  display: flex;
  height: 50vh;
  border: 1px solid #d8d9de;
  border-radius: 4px;
}
.body-content .content-left .left-header{
  display: flex;
  align-items: center;
  padding: 12px;
}
.body-content .content-left {
  border-right: 1px solid #d8d9de;
  flex-grow: 1;
  position: relative;
}
.body-content .content-left .content{
  height: calc(100% - 6.5rem);
  overflow: auto;
}
.body-content .content-left .left-bottom{
  padding: 10px 25px;
}
.content-body{
  padding: 10px;
  padding-right: 20px;
  overflow-y: auto;
  height: calc(100% - 4.5rem);
}
.content-body .content-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}
.content-body .content-item .content-item-text{
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 0.9375rem;
  color: #1f2329;
  text-overflow: ellipsis;
  font-weight: 500;
}
.content-body .content-item .content-item-text .icon{
  margin-right: 10px;
}
.custom-tree-node{
  font-size: 0.9375rem;
  color: #1f2329;
  text-overflow: ellipsis;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
}
::v-deep .device-tree .el-tree-node .el-tree-node__content{
  padding: 5px 0!important;
}
::v-deep .device-tree .el-tree-node .el-tree-node__children{
  margin-left: 20px;
}
.custom-tree-node .label{
  margin-left: 8px;
}
.body-content .content-right {
  padding-left: 12px;
  position: relative;
  width: 50%;
  min-width: 50%;
}
.body-content .content-right .content-title{
  padding: 12px;
  font-size: 0.9375rem;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.body-content .content-right .content-title .deleteAll{
  color: #3172f6;
  position: absolute;
  right: 20px;
  top: 16px;
  cursor: pointer;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
}
.body-content .content-right .content{
  height: 100%;
}
.block-checkbox {
  display: block;
  margin-bottom: 8px; /* 可选：添加间距 */
  font-size: 14px;
  color: #1f2329;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 8px 15px;
}
.diglog_h {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid #cfd4e8;
  color: #1a1a1a;
}

.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.available_frame_bto {
  display: flex;
  align-items: center;
  justify-content: center;
}

.available_frame_cancel {
  width: 100px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  font-size: 15px;
  color: #7e84a3;
  margin-right: 30px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.available_frame_comfin {
  width: 100px;
  height: 40px;
  background: #0058ff;
  border-radius: 4px 4px 4px 4px;
  font-size: 15px;
  color: white;
  text-align: center;
  cursor: pointer;
}
</style>